import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/actions-runner/_work/pteultra-home/pteultra-home/app/app-update/StoreButtons.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/actions-runner/_work/pteultra-home/pteultra-home/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/app/actions-runner/_work/pteultra-home/pteultra-home/node_modules/next/dist/client/image-component.js");
